import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "src/components/ui/dialog";
import { FiExternalLink } from "react-icons/fi";

export const SAMPLE_LABORPASS_URL =
	"https://www.development.laborhack.com/pros/@jane.doe";

interface SampleLaborPassModalProps {
	isOpen: boolean;
	onOpenChange: (open: boolean) => void;
}

export const SampleLaborPassModal = ({
	isOpen,
	onOpenChange,
}: SampleLaborPassModalProps) => {
	return (
		<Dialog open={isOpen} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-[min(1100px,calc(100vw-2rem))] overflow-hidden rounded-none border-0 bg-white p-0 shadow-[0_32px_80px_rgba(18,18,18,0.18)]">
				<DialogHeader className="border-b border-[#E7E7E7] px-6 py-5 text-left md:px-8">
					<DialogTitle className="font-[AeonikPro] text-2xl text-[#121212]">
						View sample LaborPass
					</DialogTitle>
					<DialogDescription className="text-sm text-[#666666] md:text-base">
						Preview a completed LaborPass before you start building your own.
					</DialogDescription>
				</DialogHeader>

				<div className="space-y-4 p-4 md:p-6">
					<a
						href={SAMPLE_LABORPASS_URL}
						target="_blank"
						rel="noreferrer"
						className="inline-flex items-center gap-2 text-sm font-semibold text-[#E0623A] transition hover:text-[#C6522D]"
					>
						Open sample in a new tab
						<FiExternalLink className="h-4 w-4" />
					</a>

					<div className="overflow-hidden rounded-none border border-[#E7E7E7] bg-[#F6F6F6]">
						<iframe
							src={SAMPLE_LABORPASS_URL}
							title="Sample LaborPass"
							className="h-[70vh] w-full bg-white"
						/>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};
